import { Link } from "react-router-dom";
import { BOM } from "../../../../services/definedMethod";

/*!*******************************************************************************!
  !***FX-TRANSACTION SALES  API CONFIG                                                       ***!
  \*******************************************************************************/
export const salesTransactionApi = {
  // Sales Transaction
  salesTransaction: BOM.baseUrl("fxtransactions"),
  newSalesTransaction: BOM.baseUrl("fxtransactions/sell"),
  GetCurrencies: BOM.baseUrl("currencies"),
  GetLocalCurrencies: BOM.baseUrl("fxtransactions/localcurrency"),
  GetByAccountNo: BOM.baseUrl("savingsaccounts/findbyaccountno"),
  GetFxCharges: BOM.baseUrl("savingsproducts"),
  convertAmount: BOM.baseUrl("fxtransactions"),
};

/*!*******************************************************************************!
  !*** FX-TRANSACTION SALES  LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const salesTransactionLabel = {
  manageSalesTransaction: "Manage FX Sales Transaction",
  newSalesTransaction: "New FX Sales Transaction",
  salesTransactionDetail: "FX Sales Transaction  Detail",
  transactionDate: "Transaction Date",
  amountACY: "Amount ACY",
  accountNo: "Account No",
  transactionType: "Transaction Type",
  accountName: "Account Name",
  accountCurrency: "Account Currency",
  transactionCCY: "Transaction CCY",
  amountLCY: "Amount LCY",
  amountTCY: "Amount TCY",
  charge: "Charge",
  currencyRate: "Currency Rate",
  chargeId: "Charge Id",
  currency: "Currency",
  salesTransactionSetup: "Sales Transaction Setup",
  newSalesTransactionMsg: "FX Sales Transaction was successfully created",
  editSalesTransactionMsg: "FX Sales Transaction was successfully edited",
  generalInfo: "General Information",
};

/*!*******************************************************************************!
    !*** FX-TRANSACTION PURCHASE STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const salesTransactionStatic = {
  manageSalesTransactionItems: [
    { title: salesTransactionLabel.manageSalesTransaction },
  ],
  detailSalesTransactionItems: [
    {
      title: (
        <Link to="/tlo1200">
          {salesTransactionLabel.manageSalesTransaction}
        </Link>
      ),
    },
    { title: salesTransactionLabel.salesTransactionDetail },
  ],
  newSalesTransactionItems: [
    {
      title: (
        <Link to="/tlo1200">
          {salesTransactionLabel.manageSalesTransaction}
        </Link>
      ),
    },
    { title: salesTransactionLabel.newSalesTransaction },
  ],
  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  transactionTypeData: [
    { label: "Purchase", value: "1" },
    { label: "Sale", value: "2" },
  ],
};
